/**
 * Declaration of Non-Beneficial Owner (Not a BO) — M32110
 * Member → Company 레터. [[Signers]] = 선언하는 Member.
 */
export type DeclarationNonBoFieldType = 'text' | 'date' | 'entity' | 'person' | 'address';

export const DECLARATION_NON_BO_KEYS = [
  'member_name',
  'member_address',
  'letter_date',
  'company_name',
  'company_registration_no',
] as const;

export type DeclarationNonBoFieldKey = (typeof DECLARATION_NON_BO_KEYS)[number];

const LABELS: Record<string, string> = {
  member_name: 'Member Name',
  member_address: 'Member Address',
  letter_date: 'Letter Date',
  company_name: 'Company Name',
  company_registration_no: 'Registration No.',
};

export function labelize(key: string): string {
  return LABELS[key] || key.replace(/_/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase());
}

export function typeOf(key: string): DeclarationNonBoFieldType {
  if (key === 'letter_date' || /_date$/.test(key)) return 'date';
  if (/_address$/.test(key)) return 'address';
  if (key === 'member_name') return 'person';
  if (key === 'company_name') return 'entity';
  return 'text';
}

export function isOptional(key: string): boolean {
  return key === 'member_address';
}

/** required progress keys */
export const DECLARATION_NON_BO_REQUIRED = DECLARATION_NON_BO_KEYS.filter((k) => !isOptional(k));
